import PropTypes from "prop-types";
import { theme } from "../../../theme";
import Button from "../../Button/Button";
import Typography from "../../Typography";
import {
	BlockHeader,
	BlockHeaderContent,
	EmptyStateText,
	NotificationRowCopy,
	PrefsForm,
	SettingsBlock,
	BillingSection,
	SettingsLayout,
	SettingsLayoutActions,
} from "./UserSettingsTabPrimitives";

function UserSettingsBillingTab({
	t,
	user,
	billingInvoicesLoaded,
	billingInvoicesTotal,
	getBillingProfileSummary,
	getInvoicesSummary,
	onOpenBillingProfile,
	onOpenInvoices,
}) {
	return (
		<SettingsBlock>
			<BlockHeader>
				<BlockHeaderContent>
					<Typography as="h2" $variant="title-5-semibold" $variantMobile="body-1-medium" $variantTablet="body-1-medium">
						{t("settings.billing.title")}
					</Typography>
				</BlockHeaderContent>
			</BlockHeader>
			<PrefsForm>
				{user ? (
					<>
						<BillingSection>
							<SettingsLayout>
								<NotificationRowCopy>
									<Typography as="span" $variant="body-1-semibold">
										{t("settings.billing.profile.title")}
									</Typography>
									<Typography
										as="span"
										$variant="body-2-medium"
										color={theme.colors.defaultWeak}
									>
										{getBillingProfileSummary()}
									</Typography>
								</NotificationRowCopy>
								<SettingsLayoutActions>
									<Button
										$variant="outline"
										onClick={onOpenBillingProfile}
										size="l"
										sizeTablet="m"
										sizeMobile="m"
									>
										{user.billingProfileCompleted
											? t("settings.billing.profile.update")
											: t("settings.billing.profile.create")}
									</Button>
								</SettingsLayoutActions>
							</SettingsLayout>
						</BillingSection>
						{billingInvoicesLoaded && billingInvoicesTotal > 0 && (
							<BillingSection>
								<SettingsLayout>
									<NotificationRowCopy>
										<Typography as="span" $variant="body-1-semibold">
											{t("settings.billing.invoices.title")}
										</Typography>
										<Typography
											as="span"
											$variant="body-2-medium"
											color={theme.colors.defaultWeak}
										>
											{getInvoicesSummary()}
										</Typography>
									</NotificationRowCopy>
									<SettingsLayoutActions>
										<Button
											$variant="outline"
											onClick={onOpenInvoices}
											size="l"
											sizeTablet="m"
											sizeMobile="m"
										>
											{t("settings.billing.invoices.view")}
										</Button>
									</SettingsLayoutActions>
								</SettingsLayout>
							</BillingSection>
						)}
					</>
				) : (
					<BillingSection>
						<EmptyStateText>Cargando…</EmptyStateText>
					</BillingSection>
				)}
			</PrefsForm>
		</SettingsBlock>
	);
}

UserSettingsBillingTab.propTypes = {
	t: PropTypes.func.isRequired,
	user: PropTypes.object,
	billingInvoicesLoaded: PropTypes.bool.isRequired,
	billingInvoicesTotal: PropTypes.number.isRequired,
	getBillingProfileSummary: PropTypes.func.isRequired,
	getInvoicesSummary: PropTypes.func.isRequired,
	onOpenBillingProfile: PropTypes.func.isRequired,
	onOpenInvoices: PropTypes.func.isRequired,
};

export default UserSettingsBillingTab;
